module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "narcologist"
  }, [_c('v-card', {
    staticClass: "modal-container nark-card"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "another-content"
  }, [_c('div', {
    staticClass: "modal-title"
  }, [_vm._v("вызвать нарколога")]), _vm._v(" "), _c('div', {
    staticClass: "modal-input"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Имя"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "номер телефона"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    directives: [{
      name: "btn",
      rawName: "v-btn"
    }],
    staticClass: "modal-button-send"
  }, [_vm._v("отправить")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-nark"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(" ВЫЗОВ НАРКОЛОГА НА ДОМ")]), _vm._v("\n            По статистике, большинство нуждающихся в помощи, начинают лечение наркомании с экстренного вытрезвления на дому, в родных для пациента стенах. Здесь больной охотнее идет на первичный контакт, чувствует себя защищеннее.\n            Скорая наркологическая помощь работает круглосуточно, осуществляет экстренный выезд в кратчайшие сроки.\n            Обеспечивается полная анонимность. Реанимобили не имеют опознавательных знаков, свидетельствующих о прибытии наркологической службы.\n            Помните, что попытки медикаментозного прерывания ломки на дому своими силами, имеют риск высокой вероятности развития дальнейших осложнений.\n\n            "), _c('p', {
    staticClass: "title"
  }, [_vm._v(" Вызывая нарколога на дом вы получаете: ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n                    экстренный безопасный вывод из запоя, снятие ломки на дому;\n                ")]), _vm._v(" "), _c('li', [_vm._v("\n                    полное очищение организма от алкоголя и токсичных веществ с помощью медикаментов, инфузионной терапии, комплекса очистительных процедур;\n                ")]), _vm._v(" "), _c('li', [_vm._v("\n                    получение высококвалифицированной мотивационной терапии, убеждение больного в необходимости дальнейшей реабилитации\n                ")]), _vm._v(" "), _c('li', [_vm._v("\n                    полная анонимность лечения;\n                ")]), _vm._v(" "), _c('li', [_vm._v("\n                    высокий уровень комфорта и защищенности в домашних условиях;\n                ")]), _vm._v(" "), _c('li', [_vm._v("\n                    получение качественной медицинской консультации на дому;\n                ")]), _vm._v(" "), _c('li', [_vm._v("\n                    диагностика общего состояния больного и возможность подбора индивидуального плана дальнейшего лечения.\n                ")])]), _vm._v("\n            Вызов нарколога на дом является хорошей предпосылкой для убеждения больного начать комплексное лечение наркомании и алкогольной зависимости в реабилитационном центре.\n        ")]), _vm._v(" "), _c('hr', {
    staticClass: "line-delet"
  }), _vm._v(" "), (_vm.getCurrentPage) ? _c('div', {
    class: _vm.getUser ? 'isEdit' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.getCurrentPage.hb1)
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.getCurrentPage.hb1, 'hb1')
      }
    }
  }) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-289d09b9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Narcologist/index.vue
// module id = 125
// module chunks = 2